<template>
  <div class="jps-interact-inner">
    <a :href="twitterUrl()" class="jps-sns-x">
      <BaseIcon name="icon/sns-x-logo" alt="X（Twitter）"/>
    </a>
    <a :href="facebookUrl()" class="jps-sns-facebook">
      <BaseIcon name="icon/sns-fb-24px" alt="Facebook"/>
    </a>
    <a :href="lineUrl()" class="jps-sns-line">
      <BaseIcon name="icon/sns-line-24px" alt="LINE"/>
    </a>
    <UiButtonIcon
      tag="button"
      class="jps-icon-button jps-icon-button-mail"
      arialabel="メール"
      @click.stop="sendMail()"
      icon-size="size-3"
      icon="mdi/email-outline"
    />
  </div>
</template>

<script lang="ts" setup>
const { langFullPath } = useI18n()
const { getHashTag } = useSite()

interface Props {
  type: Key
  data: { id: string }
}
const props = withDefaults(defineProps<Props>(),{
})

const emits = defineEmits(['close'])

const sendMail =  () => {
  emits('close')
  window.location.href = `mailto:?subject=&body=${url.value}`
}

const url = computed(() => {
  return langFullPath(`/${props.type}/${props.data.id}`)
})

const twitterUrl = () => {
  return `https://twitter.com/share?url=${encodeURIComponent(url.value)}&hashtags=${encodeURIComponent(getHashTag())}`
}

const facebookUrl = () => {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url.value
  )}`
}

const lineUrl = () => {
  return `http://line.me/R/msg/text/?${encodeURIComponent(url.value)}`
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-interact-inner {
  display: flex;
  align-items: center;
  .jps-icon {
    color: $white !important;
    svg {
      padding-bottom: 3px;
    }
    height: 3rem;
  }
  a {
    padding: 0.5rem;
    height: 3rem;
  }
  .jps-sns-x {
    svg {
      width: 1.6rem !important;
      height: 2rem !important;
    }
  }
  .jps-sns-facebook, .jps-sns-line {
    svg {
      width: 2rem !important;
      height: 2rem !important;
    }
  }
  .jps-icon-button-mail {
    padding: 0.5rem;
  }
}
.jps-icon-button-mail {
  color: $white;
  :hover {
    color: $white;
  }
}
</style>
